import { usePwaViewportWidth } from "../../hooks/useScreenWidth";
import { RootContainer } from "../../styles/Container.style";
import { Image, LinkOvl } from "../Informations.page";

export default function DogBodyLanguagePage() {
  const viewportWidth = usePwaViewportWidth();
  const links = [
    "https://www.pdsa.org.uk/pet-help-and-advice/looking-after-your-pet/puppies-dogs/canine-ladder-of-communication",
    "https://www.akc.org/expert-advice/advice/how-to-read-dog-body-language/",
    "https://www.rspca.org.uk/adviceandwelfare/pets/dogs/behaviour/understanding",
    "https://www.dogstrust.org.uk/dog-advice/understanding-your-dog/body-language",
    "https://www.battersea.org.uk/pet-advice/dog-advice/understanding-your-dogs-body-language",
  ];
  return (
    <RootContainer $alignItem="center">
      <Image $width={viewportWidth + "px"} src="/informations/dog-body-language.png" />
      {links.map((link, index) => (
        <LinkOvl
          key={link}
          to={link}
          target="_blank"
          rel="noopener noreferrer"
          $top={20.3 + index * 0.8 + index * 10}
          $left={9}
        />
      ))}
    </RootContainer>
  );
}
